export const defaultEditorOptions = {
  minHeight: "200px",
  language: "en-US",
  useCommandShortcut: true,
  usageStatistics: false,
  hideModeSwitch: true,
  toolbarItems: [
    ["heading", "bold", "italic", "strike"],
    ["hr", "quote"],
    ["ul", "ol", "task", "indent", "outdent"],
    ["table", "link", "image"],
    ["code", "codeblock"],
    ["scrollSync"],
  ],
};
